const isPageActive = (string: string) => {
	if (window.location.pathname.indexOf(string) >= 0) {
		return true;
	}
	return false;
};

export default isPageActive;
